import './index.scss';
import React, { useEffect, useState } from 'react';
import Utils from '../../Helper/utils';

function ModalEditSlideName({slides, setSlides, selectedSlideIndex, selectedSlide, reRender}) {
    const [slideTitleState, setSlideTitleState] = useState(selectedSlide ? selectedSlide.name : null);

    const handleOnChange = (e) => {
        let currentValue = e.currentTarget.value;
        setSlideTitleState(currentValue);
    }

    const handleSaveSlideName = () => {
        if (slideTitleState.length < 4 || slideTitleState.length > 50) {
            Utils.showError('Slide Name minimum 4 and maximum 50');
            return false;
        }
        let needReRender = selectedSlide.name !== slideTitleState ? true : false;
        selectedSlide.name = slideTitleState;
        setSlides(slides);
        window.jQuery('#tbcourse-modal-edit-slide-name').modal('hide');
        if (needReRender) {
            reRender();
        }
        // updateLessonTitle({ lessonTitle: inputTitleElmValue, lessonDescription: inputDescriptionElm });
        // window.jQuery('#tbcourse-modal-edit-lesson-title').modal('hide');
    }

    useEffect(() => {
        if(selectedSlide) {
            setSlideTitleState(selectedSlide.name);
        }
    }, [selectedSlide]);

    return (
        <div className={`tbcourse-modal tbcourse-modal-edit-slide-name modal`} id="tbcourse-modal-edit-slide-name" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h5 className="modal-title font-size-24">Edit Slide Name</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body font-size-14 font-family-inter">
                        <div className="form-group">
                            <label htmlFor="input-edit-slide-name" className="text-uppercase mb-2">Slide Name</label>
                            <input
                                type="text"
                                id="input-edit-slide-name"
                                className="form-control"
                                placeholder="Slide Name"
                                value={slideTitleState}
                                onChange={handleOnChange}
                            />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary font-weight-bold rounded-6 font-size-12 px-5 py-2" onClick={handleSaveSlideName}>Save</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalEditSlideName;